//
//
//
//
//
//


import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'

export default {
    name: 'Posture_flank',
    directive: {
        bModalDirective
    },
    components: {

    },
    props : [
        'severeRisks',
        'mildRisks',
        'normalRisks',
        'points',
        'photos'
    ],
    data(){
        return {
            img: {
              face: null,
              side: null
            },
        };
    },
    computed: {

    },
   methods: {
      getRiskImg(risk){
        //.log("risk ==>" + JSON.stringify(risk))
        let direction = 'normal';
        let img;

        if(!_.isNull( risk.direction) && risk.key !== 'legO' && risk.key !== 'legX' && risk.key !== 'legXO' && risk.key !== 'kneeOverstretch'){
          direction = risk.direction
        }
        if(this.checkIfAbnormal(risk.level)){
          img = risk.abnormal[direction];
        }else{
          img = risk.normal[direction];
        }
        return img;
      },
      setSymptomCanvasModal (risk) {
        let points = this.points
        let needDetail = ['legO', 'legX', 'legXO']
        let forSide = ['headLean', 'roundShoulder', 'kneeOverstretch']

        let riskKey = risk.key
        let keyMap = this.keyMap
        let positionArr
        let positionPointsArr = []
        let faceOrSide
        let scale



        Object.keys(keyMap).forEach(function (direction, index) {
          Object.keys(keyMap[direction]).forEach(function (key, index) {
            if (key === riskKey) {
              positionArr = keyMap[direction][key].position
              scale = keyMap[direction][key].scale
            }
          })
        })



        if (needDetail.indexOf(riskKey) !== -1) {
          // 当是 legO、legX、legXO 时
          let lOrR
          if (risk.detail === '右腿') {
            lOrR = 'right'
          } else {
            lOrR = 'left'
          }

          for (let i = 0; i < positionArr.length; i++) {
            positionPointsArr.push(points.face[positionArr[i]][lOrR])
          }

          faceOrSide = 'face'
        }
        else if (forSide.indexOf(riskKey) !== -1) {
          // 当是侧面时
          let lOrR = this.conclusion.side.side

          for (let i = 0; i < positionArr.length; i++) {

            if (points.side[positionArr[i]].left === undefined) {

              positionPointsArr.push(points.side[positionArr[i]])
            } else {
              positionPointsArr.push(points.side[positionArr[i]][lOrR])
            }
          }

          faceOrSide = 'side'
        }
        else {
          // 正面，并且能取到左右时
          for (let i = 0; i < positionArr.length; i++) {
            let positionAndDirectionArr = positionArr[i].split('-')
            if (positionAndDirectionArr.length === 1) {
              positionPointsArr.push(points.face[positionAndDirectionArr[0]])
            } else {
              positionPointsArr.push(points.face[positionAndDirectionArr[0]][positionAndDirectionArr[1]])
            }
          }

          faceOrSide = 'face'
        }



        let _x = Math.abs(positionPointsArr[0].x - positionPointsArr[1].x)
        let _y = Math.abs(positionPointsArr[0].y - positionPointsArr[1].y)
        let xMid = (positionPointsArr[0].x + positionPointsArr[1].x) / 2
        let yMid = (positionPointsArr[0].y + positionPointsArr[1].y) / 2

        let width = _x > _y ? _x : _y
        width *= (1 + scale)

        let x = xMid - width / 2
        let y = yMid - width / 2


        let canvas = document.createElement('canvas')
        let ctx = canvas.getContext('2d')
        canvas.style.width = '100%'
        canvas.style.height = '100%'
        canvas.width = width
        canvas.height = width
        // let img = new Image();
        // img.src = this.photos[faceOrSide];

        let img = this.img[faceOrSide]

        ctx.drawImage(img, x, y, width, width, 0, 0, width, width)


        this.canvas = canvas
      },
      setSymptomCanvas (option) {
        let canvas = option.el
        let ctx = canvas.getContext('2d')

        let points = this.points
        let needDetail = ['legO', 'legX', 'legXO']
        let forSide = ['headLean', 'roundShoulder', 'kneeOverstretch']

        let riskKey = canvas.dataset.key
        let keyMap = this.keyMap
        let positionArr
        let positionPointsArr = []
        let faceOrSide
        let scale
        Object.keys(keyMap).forEach(function (direction, index) {
          Object.keys(keyMap[direction]).forEach(function (key, index) {
            if (key === riskKey) {
              positionArr = keyMap[direction][key].position
              scale = keyMap[direction][key].scale
            }
          })
        })



        if (needDetail.indexOf(riskKey) !== -1) {
          // 当是 legO、legX、legXO 时
          let lOrR
          if (canvas.dataset.detail === '右腿') {
            lOrR = 'right'
          } else {
            lOrR = 'left'
          }

          for (let i = 0; i < positionArr.length; i++) {
            positionPointsArr.push(points.face[positionArr[i]][lOrR])
          }

          faceOrSide = 'facet'
        } else if (forSide.indexOf(riskKey) !== -1) {
          // 当是侧面时
          let lOrR = this.conclusion.side.side

          for (let i = 0; i < positionArr.length; i++) {

            if (points.side[positionArr[i]].left === undefined) {

              positionPointsArr.push(points.side[positionArr[i]])
            } else {
              positionPointsArr.push(points.side[positionArr[i]][lOrR])
            }
          }

          faceOrSide = 'side'
        } else {
          // 正面，并且能取到左右时
          for (let i = 0; i < positionArr.length; i++) {
            let positionAndDirectionArr = positionArr[i].split('-')
            if (positionAndDirectionArr.length === 1) {
              positionPointsArr.push(points.face[positionAndDirectionArr[0]])
            } else {
              positionPointsArr.push(points.face[positionAndDirectionArr[0]][positionAndDirectionArr[1]])
            }
          }

          faceOrSide = 'facet'
        }



        let _x = Math.abs(positionPointsArr[0].x - positionPointsArr[1].x)
        let _y = Math.abs(positionPointsArr[0].y - positionPointsArr[1].y)
        let xMid = (positionPointsArr[0].x + positionPointsArr[1].x) / 2
        let yMid = (positionPointsArr[0].y + positionPointsArr[1].y) / 2

        let width = _x > _y ? _x : _y
        width *= (1 + scale)

        let x = xMid - width / 2
        let y = yMid - width / 2


        canvas.style.width = '100%'
        canvas.style.height = '100%'
        canvas.width = width
        canvas.height = width
        let img = new Image();
        img.src = this.photos[faceOrSide];
        // img.src = this.img[faceOrSide]
        img.onload=function(){
          ctx.drawImage(img, x, y, width, width, 0, 0, width, width)
        }

      },

      getLevel (level) {
        switch (level) {
          case this.level.normal:
            return {
              des: '低风险',
              className: 'level-normal'
            }
          case this.level.mild:
            return {
              des: '中风险',
              className: 'level-mild'
            }
          case this.level.severe:
            return {
              des: '高风险',
              className: 'level-severe'
            }
        }
      },
      checkIfAbnormal(level) {
        switch (level) {
          case this.level.normal:
            return false
          case this.level.mild:
            return false
          case this.level.severe:
            return true
        }
      },
      sortHighToLow (arr) {
        return _.orderBy(arr, ['value'], ['desc'])
      },
      initRiskBar () {
        this.$refs.riskModalRef.$el.getElementsByClassName('modal-content')[0].scrollTop = 0
        let modalRiskBar = document.getElementById('modalRiskBar')
        canvas.initRiskLevel({
          el: modalRiskBar,
          width: Number(modalRiskBar.parentNode.offsetWidth),
          height: Number(modalRiskBar.parentNode.offsetHeight),
          color: {
            normal: '#00d963',
            mild: '#ffbf00',
            severe: '#ff4d4d'
          },
          level: this.level
        })
      },
      initRisksData () {
        let risks = this.risks
        let level = this.level
        let symptoms = this.symptoms
        let normalRisks =this.normalRisks;
        let mildRisks =this.mildRisks;
        let severeRisks =this.severeRisks;

        for (let direction in risks) {
          for (let i = 0; i < risks[direction].length; i++) {
            let symptom = symptoms[risks[direction][i].position][risks[direction][i].code - 1]

            if (symptom.value) {
              let otherSymptom = Object.assign({}, symptom)
              if (!risks[direction][i].valid) {
                otherSymptom.raw = 0
                otherSymptom.value = 0
                otherSymptom.level = level.normal
                otherSymptom.detail = ''
                otherSymptom.direction = 'normal'
              } else {
                otherSymptom.raw = risks[direction][i].raw ? risks[direction][i].raw : 0
                otherSymptom.value = risks[direction][i].value ? risks[direction][i].value : 0
                otherSymptom.level = risks[direction][i].level ? risks[direction][i].level : level.normal
                otherSymptom.detail = risks[direction][i].detail ? risks[direction][i].detail : ''
                otherSymptom.direction = risks[direction][i].direction ? risks[direction][i].direction : 'normal'
              }

              symptoms[risks[direction][i].position].push(otherSymptom)
            } else {
              if (!risks[direction][i].valid) {
                symptom.raw = 0
                symptom.value = 0
                symptom.level = level.normal
                symptom.detail = ''
                symptom.direction = 'normal'
              } else {
                symptom.raw = risks[direction][i].raw ? risks[direction][i].raw : 0
                symptom.value = risks[direction][i].value ? risks[direction][i].value : 0
                symptom.level = risks[direction][i].level ? risks[direction][i].level : level.normal
                symptom.detail = risks[direction][i].detail ? risks[direction][i].detail : ''
                symptom.direction = risks[direction][i].direction ? risks[direction][i].direction : 'normal'
              }
            }
          }
        }

        for (let position in symptoms) {
          for (let i = 0; i < symptoms[position].length; i++) {
            if (_.isUndefined(symptoms[position][i].value)) {
              continue
            }
            switch (symptoms[position][i].level) {
              case level.normal:
                normalRisks.push(symptoms[position][i])
                break
              case level.mild:
                mildRisks.push(symptoms[position][i])
                break
              case level.severe:
                severeRisks.push(symptoms[position][i])
                break
              default:
                normalRisks.push(symptoms[position][i])
                break
            }
          }
        }

        this.normalRisks = this.sortHighToLow(normalRisks)
        this.mildRisks = this.sortHighToLow(mildRisks)
        this.severeRisks = this.sortHighToLow(severeRisks)





      },
      initRiskPoints () {
        let that = this
        let points = this.points
        let photos = this.photos
        let faceCanvas = document.createElement('canvas')
        let sideCanvas = document.createElement('canvas')
        let _this = this
        let risks = this.normalRisks.concat(this.mildRisks, this.severeRisks)
        

        // === 初始化侧面数据 ===
        let side = points.side
        let sidePointsArr = []
        let sideImg = new Image()


        // 人体骨架分组
        let lOrR = side.side
        let sideOrder = [
          [
            `ankle-${lOrR}`,
            `knee-${lOrR}`,
            `hip-${lOrR}`,
            `shoulder-${lOrR}`,
            // `neck`,
            `elbow-${lOrR}`,
            `wrist-${lOrR}`
          ],
          [
            //`neck`,
            `shoulder-${lOrR}`,//新增
            `ear-${lOrR}`,
            `eye-${lOrR}`,
            `nose`
          ]
        ]
        ////console.log('side order:',sideOrder)
        // 垂直标准线
        let sideVerticalStandard = [`ankle-${lOrR}`, `nose`]
        let sideVerticalPointsArr = []

        // 先将各分组数据点取出来
        for (let i = 0; i < sideOrder.length; i++) {
          let pointsArr = []
          for (let j = 0; j < sideOrder[i].length; j++) {
            let positionArr = sideOrder[i][j].split('-')
            if (positionArr.length === 1) {
              pointsArr.push(side[positionArr[0]])
            } else {
              pointsArr.push(side[positionArr[0]][positionArr[1]])
            }
          }
          sidePointsArr.push(pointsArr)
        }

        // 将垂直标准点取出来
        for (let i = 0; i < sideVerticalStandard.length; i++) {
          let positionArr = sideVerticalStandard[i].split('-')
          if (positionArr.length === 1) {
            sideVerticalPointsArr.push(side[positionArr[0]])
          } else {
            sideVerticalPointsArr.push(side[positionArr[0]][positionArr[1]])
          }
        }

        // 症状和位置对应
        let sideSymptomWithPosition = ['ear-shoulder', 'hip-knee']
        let sideHorizontalArr = []

        for (let i = 0; i < sideSymptomWithPosition.length; i++) {
          let horizontalArr = []
          let positionArr = sideSymptomWithPosition[i].split('-')
          for (let j = 0; j < positionArr.length; j++) {
            horizontalArr.push(side[positionArr[j]][lOrR])
          }
          sideHorizontalArr.push(horizontalArr)
        }

        // 取出需要显示度数的症状
        let sideSymptomWithAngle = ['headLean', 'roundShoulder', 'kneeOverstretch']
        let sideSymptomWithAngleRisk = []

        for (let i = 0; i < sideSymptomWithAngle.length; i++) {
          for (let j = 0; j < risks.length; j++) {
            if (risks[j].key === sideSymptomWithAngle[i]) {
              sideSymptomWithAngleRisk.push(risks[j])
            }
          }
        }

        //console.log("sideImg.src:that.img",that.img)

        // 开始画图以及各点线
        sideImg.src = photos.side
        sideImg.onload = function () {
          that.img.side = sideImg
          // 将图片画进 canvas
          let width = sideImg.width
          let height = sideImg.height
          sideCanvas.width = width
          sideCanvas.height = height
          sideCanvas.style.width = '100%'

          let cxt = sideCanvas.getContext('2d')
          cxt.drawImage(sideImg, 0, 0, width, height)

          // 按分组画线
          for (let i = 0; i < sidePointsArr.length; i++) {
            for (let j = 0; j < sidePointsArr[i].length; j++) {

              if (j === 0 || (sidePointsArr[i][j].x === 0 && sidePointsArr[i][j].y === 0) || (sidePointsArr[i][j - 1].x === 0 && sidePointsArr[i][j - 1].y === 0)) {
                if (sidePointsArr[i][j].x === 0 && sidePointsArr[i][j].y === 0) {
                  continue
                }/*else if ( j == 0) {

                    }*/else {
                  _this.drawPoint({
                    el: sideCanvas,
                    point: sidePointsArr[i][j]
                  })
                  continue
                }
              } else {
                _this.drawPoint({
                  el: sideCanvas,
                  point: sidePointsArr[i][j]
                })
                if(j != 3 ){
                  _this.drawLine({

                    el: sideCanvas,
                    points: [sidePointsArr[i][j], sidePointsArr[i][j - 1]]
                  })
                }

              }
            }
          }

          // 画垂直标准线
          for (let i = 0; i < sideVerticalPointsArr.length; i++) {
            if (sideVerticalPointsArr[i].x === 0 && sideVerticalPointsArr[i].y === 0) {
              continue
            } else {
              cxt.save()
              cxt.strokeStyle = '#4db664'
              cxt.beginPath()
              cxt.moveTo(sideVerticalPointsArr[i].x, 0)
              cxt.lineTo(sideVerticalPointsArr[i].x, height)
              cxt.closePath()
              cxt.stroke()
              cxt.restore()

              cxt.save()
              cxt.fillStyle = '#fe610f'
              cxt.font = '30px serif'
              let windowWidth = document.documentElement.clientWidth
              let windowHeight = window.screen.height
              let offsetHeight = (windowHeight - 125) / (windowWidth / width)
              if (i === 0) {
                cxt.fillText('α', sideVerticalPointsArr[i].x + 5, offsetHeight - 5)
              } else {
                cxt.fillText('β', sideVerticalPointsArr[i].x + 5, offsetHeight - 5)
              }
              cxt.restore()
            }
          }

          // 画斜线
          for (let i = 0; i < sideHorizontalArr.length; i++) {
            _this.drawLine({
              el: sideCanvas,
              points: sideHorizontalArr[i],
              isSide: true
            })
          }

          // 画症状度数
          for (let i = 0; i < sideSymptomWithAngleRisk.length; i++) {
            _this.drawRectAndAngle({
              cxt: cxt,
              angle: sideSymptomWithAngleRisk[i].raw.toFixed(1),
              point: {
                x: width - 120,
                y: height * 0.2 * (i + 1)
              }
            })
          }

         _this.$nextTick(function () {
            document.getElementById('side').appendChild(sideCanvas)
          })
        }
      },
      drawPoint (option) {
        let canvas = option.el
        let point = option.point
        let cxt = canvas.getContext('2d')
        cxt.save()
        cxt.fillStyle = '#009eff'
        cxt.beginPath()
        cxt.arc(point.x, point.y, 5, 0, 2 * Math.PI)
        cxt.closePath()
        cxt.fill()
        cxt.restore()
        cxt.save()
        cxt.fillStyle = 'rgba(83, 158, 255, .3)'
        cxt.beginPath()
        cxt.arc(point.x, point.y, 10, 0, 2 * Math.PI)
        cxt.closePath()
        cxt.fill()
        cxt.restore()
      },
      drawLine (option) {
        //console.log("option:",option)
        // 有一个点是x, y 都等于0的时候，不画线
        if ((option.points[0].x === 0 && option.points[0].y === 0) || (option.points[1].x === 0 && option.points[1].y === 0)) {
          return
        }
        let canvas = option.el
        let points = option.points
        let cxt = canvas.getContext('2d')
        cxt.save()
        cxt.lineWidth = 3
        if (!option.isSide) {
          cxt.strokeStyle = '#5f58f4'
          cxt.beginPath()
          cxt.moveTo(points[0].x, points[0].y)
          cxt.lineTo(points[1].x, points[1].y)
          cxt.closePath()
          cxt.stroke()
        } else {
          let _x = Math.abs(points[0].x - points[1].x)
          let _y = Math.abs(points[0].y - points[1].y)
          let z = Math.sqrt(Math.pow(_x, 2) + Math.pow(_y, 2))
          let startX
          let startY
          let endX
          let endY
          let distance = 80


          if (points[0].x > points[1].x) {
            startX = Math.round(points[1].x - distance * _x / z)
            startY = Math.round(points[1].y + distance * _y / z)
            endX = Math.round(points[0].x + distance * _x / z)
            endY = Math.round(points[0].y - distance * _y / z)
          } else {
            startX = Math.round(points[0].x - distance * _x / z)
            startY = Math.round(points[0].y - distance * _y / z)
            endX = Math.round(points[1].x + distance * _x / z)
            endY = Math.round(points[1].y + distance * _y / z)
          }

          cxt.strokeStyle = '#0ef8cd'
          cxt.beginPath()
          cxt.moveTo(startX, startY)
          cxt.lineTo(endX, endY)
          cxt.closePath()
          cxt.stroke()
        }

        cxt.restore()
      },
      drawRectAndAngle (option) {
        let cxt = option.cxt
        let angle = option.angle
        let point = option.point

        cxt.save()
        if (option.isSecond) {
          cxt.translate(0, 43)
        }
        cxt.save()
        cxt.fillStyle = 'rgba(100, 100, 98, 0.5)'
        cxt.beginPath()
        cxt.moveTo(point.x + 13, point.y + 3)
        cxt.lineTo(point.x + 99, point.y + 3)
        cxt.quadraticCurveTo(point.x + 109, point.y + 3, point.x + 109, point.y + 13)
        cxt.lineTo(point.x + 109, point.y + 33)
        cxt.quadraticCurveTo(point.x + 109, point.y + 43, point.x + 99, point.y + 43)
        cxt.lineTo(point.x + 13, point.y + 43)
        cxt.quadraticCurveTo(point.x + 3, point.y + 43, point.x + 3, point.y + 33)
        cxt.lineTo(point.x + 3, point.y + 13)
        cxt.quadraticCurveTo(point.x + 3, point.y + 3, point.x + 13, point.y + 3)
        cxt.closePath()
        cxt.fill()
        cxt.restore()

        // 绘制角度
        cxt.save()
        cxt.font = '34px Arial'
        cxt.fillStyle = '#0cfcca'
        cxt.textAlign = 'center'
        if (option.isTrunk) {
          cxt.fillText(`${angle}%`, point.x + 56, point.y + 38)
        } else {
          cxt.fillText(`${angle}°`, point.x + 56, point.y + 38)
        }
        cxt.restore()
        cxt.restore()
      },
      drawLineAndAngle (option) {
        let canvas = option.el
        let width = canvas.width
        let points = option.points
        let min = option.min - 100
        let max = option.max + 100
        let cxt = canvas.getContext('2d')

        // 如果有一个点不存在，则不画线
        for (let i = 0; i < points.length; i++) {
          if (points[i].x === 0 && points[i].y === 0) {
            return
          }
        }

        // 此处画脊柱侧弯

        if (points.length === 1) {
          this.drawRectAndAngle({
            cxt: cxt,
            angle: (option.angle * 100).toFixed(1),
            point: {
              x: width - 120,
              y: points[0].y
            },
            isSecond: false,
            isTrunk: true
          })
        } else {
          let _x = Math.abs(points[0].x - points[1].x)
          let _y = Math.abs(points[0].y - points[1].y)
          let startPoint = {}
          let endPoint = {}
          let offsetYL = Number(((points[0].x - min) * _y / _x).toFixed(0))
          let offsetYR = Number(((max - points[1].x) * _y / _x).toFixed(0))

          if (points[0].y < points[1].y) {
            startPoint.x = min
            startPoint.y = points[0].y - offsetYL
            endPoint.x = max
            endPoint.y = points[1].y + offsetYR
          } else {
            startPoint.x = min
            startPoint.y = points[0].y + offsetYL
            endPoint.x = max
            endPoint.y = points[1].y - offsetYR
          }

          cxt.save()
          cxt.strokeStyle = '#14bc9a'
          cxt.beginPath()
          cxt.moveTo(startPoint.x, startPoint.y)
          cxt.lineTo(endPoint.x, endPoint.y)
          cxt.closePath()
          cxt.stroke()
          cxt.restore()

          // 绘制圆角矩形框
          this.drawRectAndAngle({
            cxt: cxt,
            angle: option.angle.toFixed(1),
            point: {
              x: width - 120,
              y: points[1].y
            },
            isSecond: false
          })

          if (!_.isUndefined(option.secondAngle)) {
            this.drawRectAndAngle({
              cxt: cxt,
              angle: option.secondAngle.toFixed(1),
              point: {
                x: width - 120,
                y: points[1].y
              },
              isSecond: true
            })
          }
        }
      }
    },
    created () {
      this.initRiskPoints();
    },
}



// WEBPACK FOOTER //
// ./src/components/Posture_flank.vue